/*
 * @Author: zhao - 🍉
 * @Date: 2022-02-14 20:55:47
 * @LastEditTime: 2022-02-14 23:21:12
 * @LastEditors: zhao - 🍉
 * @Description: 收房合同房租周期
 * @FilePath: /zhzj-admin/src/services/rentCycle.js
 */

import request from "../utils/request";


/**
* 房租周期-房租周期列表
*
* @export
* @param {{ page: number, pagesize?: number, keyword?: string }} data
*/
export function fetchRentCycleList(data, option = {}) {
    return request({ url: '/platform/building/getBuildingRentCycleList', method: 'post', data, ...option })
}

/**
* 房租周期-获取房租周期详情
*
* @export
* @param {{id: number}} data
*/
export function fetchRentCycleGet(data, option = {}) {
    return request({ url: '/platform/building/getBuildingRentCycleInfo', method: 'post', data, ...option })
}

/**
* 房租周期-更新房租周期
*
* @export
* @param {*} data
*/
export function fetchRentCycleUpdate(data, option = {}) {
    return request({ url: '/platform/building/updateBuildingRentCycleInfo', method: 'post', data, ...option })
}

/**
* 房租周期-新增房租周期
*
* @export
* @param {*} data
*/
export function fetchRentCycleAdd(data, option = {}) {
    return request({ url: '/platform/building/AddBuildingRentCycleInfo', method: 'post', data, ...option })
}

/**
* 房租周期-删除房租周期
*
* @export
* @param {{id: number}} data
*/
export function fetchRentCycleDelete(params, option = {}) {
    return request({ url: '/platform/building/deleteRentCycle', method: 'post', params, ...option })
}



// WEBPACK FOOTER //
// ./src/services/rentCycle.js